import React from 'react';

import { Theme } from '@insights-gaming/theme';
import { TableCell, TableCellProps } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

type StatisticsTableCellProps = React.PropsWithChildren<TableCellProps>;

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    padding: theme.spacing(0.5),
    minWidth: 50,
  },
}), { name: 'StatisticsTableCell' });

export function StatisticsTableCell(props: StatisticsTableCellProps) {
  const classes = useStyles(props);
  const { children, ...rest } = props;
  return (
    <TableCell
    classes={{
      root: classes.root,
    }}
    align='center'
    {...rest}
    >
      {children}
    </TableCell>
  );
}
